
import { ShareObjectsController } from "@commoncore/controller/ShareObjectsController";
import { UniversalService } from "@commoncore/services/universal.service";
import { AppEvents, EventsList } from "@commoncore/utils/app-events";
import { ENV_CONSTANTS } from "@env-properties/environment";
import { USER_DETAILS } from "@mainrepo/app/core/constants/Constants";
import { PasswordEncryptorUtil } from "@mainrepo/app/core/utils/PasswordEncryptorUtil";

export class ShareAccessImplementation {
  public http: any;
  public universalService: any;
  public router: any; 
  public globalService:any;
  shareAccessService: any;
  customMetadata:any;
  showSharedFiles:any;
  listService:any;
  passwordEncryptorUtil: PasswordEncryptorUtil;
  localStorageService: any;
  shareSessionExpiry:any;
  static singleInstance:any = null;
  controller: any;
  sharePassword: any;
  sessionStorageService:any;

  constructor(globalService) {
    this.globalService=globalService;
    this.passwordEncryptorUtil=new PasswordEncryptorUtil();
    this.shareSessionExpiry = ENV_CONSTANTS["constants"]["shareSessionExpiry"];

  }

public setHandler(globalService) {
    this.controller=ShareObjectsController.getInstance(globalService);
    this.universalService = globalService.getUniversalServiceRef();
    this.shareAccessService = globalService.getShareAccessServiceRef();
    this.http = globalService.getHttpClientRef();
    this.router = globalService.getRouterRef();
    this.customMetadata = globalService.getCustomMetadataServiceRef();
    this.listService = globalService.getListServiceRef();
    this.localStorageService = globalService.getLocalStorageSvcRef();
    this.sessionStorageService = globalService.getSessionStorageSvcRef();
  }

  public static getInstance(globalService):ShareAccessImplementation{
    if(this.singleInstance == null){
      this.singleInstance = new ShareAccessImplementation(globalService);
      return this.singleInstance;
    }else{
      return this.singleInstance;
    }
  }

  

  requestAccessShareLink(url,msg){
    var self = this;  
    var params = { "message" : msg }
    return new Promise(function(resolve,reject){
        self.http.post(url,params).subscribe(
            email=>{
                resolve(email)
            },
            err=>{
              console.log("error in sending email is==>",err);
              reject(err)
            }
        )
    })
  }

  getAccessRequesterInfo(url){
    var self = this;
    return new Promise(function (resolve, reject) {
      self.http.get(url).subscribe(
        response => {
          resolve(response)
        },
        err => {
          console.log("error in getting requester ID info", err);
          reject(err);
        }
      )
    });
  }

  grantAccess(url, id, role){
    var self = this;
    var params = {
        "requesterId": id,
        "recipientRole":role
    }
    // {
    //     "requesterId":"xIqKihR0OfbgU14LFqxItQ",
    //     "recipientRole":"E"
    // }
    return new Promise(function (resolve, reject) {
      self.http.put(url,params).subscribe(
        response => {
          resolve({status:'success'})
        },
        err => {
          console.log("error in getting requester ID info", err);
          reject(err);
        }
      )
    });
  }

  redirectToSharedWithMeForLoggedInUser(){
    var url = '/shared/sharedwithme'
    // var url = "http://localhost:4200" + '/shared/sharedwithme'
    window.open(url,'_self', "noopener, noreferrer");
  }


  redirectToHomePage(toastMessage){
    if(this.universalService.inAppWebViewOpened){
      this.listService.informAndroidAndIOSToCloseWebView(toastMessage);
      return;
    }
    var url = '/home';
    // var url = "http://localhost:4200" + '/home';
    if(USER_DETAILS["USER_DETAILS"]["rootFolderKey"] != undefined && USER_DETAILS["USER_DETAILS"]["rootFolderKey"] != "") {
      url = url + '/' + USER_DETAILS["USER_DETAILS"]["rootFolderKey"];
    }
    window.open(url,"_self", "noopener, noreferrer");
  }

  redirectToSharePage(){
    if(this.universalService.inAppWebViewOpened){
      this.listService.informAndroidAndIOSToCloseWebView("");
      return;
    }
    var url = '/home'
    // var url = "http://localhost:4200" + '/home'
    window.open(url,"_self", "noopener, noreferrer");
  }

  async fetchPassword(shareKey,url) {
    var result = await this.controller.getUniversalShareLinkPassword(shareKey);
    if(result.password) {
      this.sharePassword = this.passwordEncryptorUtil.decrypytSharePassPhrase(result.password);
      var response = await this.getProtectedFilesUnivShareLink(url,this.sharePassword)
      return response["shareKey"] ? true :false;
    }else{
      return false;
    }
  }
  
  async getUnivShareLinkInfo(url){
    var self = this;  
    // let password = await this.fetchPassword(this.shareAccessService.univShareKey,url);
    // if(password == true){
    //   return
    // }else{
      self.shareAccessService.passwordNeeded = false;
      self.shareAccessService.invalidUnivShareKey = false;
      return new Promise(function(resolve,reject){
          self.http.get(url).subscribe(
              suc=>{
                  self.shareAccessService.showUnivShareLinkFiles = true;
                  //localStorage.setItem('usID',suc.sessionId);
                  self.sessionStorageService.setUnivShareLinkSessionID(suc["ulinksToken"]);
                  self.sessionStorageService.setUnivShareLinkShareKey(self.shareAccessService.univShareKey);
                  self.sessionStorageService.setShareLinkCreator(suc.shareCreatedBy);
                  self.universalService.headingTitle.set(suc["shareName"] ? suc["shareName"] : "Shared Files");
                  //self.localStorageService.setShareLinkCreator("cdbd05c621da4ccb8d42015c30de9c32");
                  
                  resolve(suc)
              },
              async err=>{
                console.log("error in univ share link info API is==>",err);
                if(err.error && err.error.code && err.error.code == "SSOM0110"){
                  let password = await self.fetchPassword(self.shareAccessService.univShareKey,url);
                  if(password == true){
                    resolve("passwordNotNeeded")
                  }
                  else{
                    self.shareAccessService.passwordNeeded = true;
                    AppEvents.emit(EventsList.EMPTY_TABBED_VIEW);
                    self.universalService.headingTitle.set("Shared Files");
                  }
                }
                else if(err.error && err.error.code && (err.error.code == "SSOM0115" || err.error.code == "SSOM0117" || err.error.code == "SCLN0062" || err.error.code == "TEJRF0404")){
                  self.shareAccessService.invalidUnivShareKey = true;
                }
                self.universalService.headingTitle.set("Shared Files");
                reject(err)
              }
          )
      })
    //}
  }

  getProtectedFilesUnivShareLink(url, pswd){
    var self = this;
    var encryptedPswd = this.encryptPass(pswd);  
    //var param = { "password" :"M/X3tQy57D+tpIEKLxbeFg===" }
    var param = { "password" : encryptedPswd }
    self.shareAccessService.univSharePswd = encryptedPswd;
    return new Promise(function(resolve,reject){
        self.http.post(url, param).subscribe(
            suc=>{
                self.shareAccessService.passwordNeeded = false;
                self.shareAccessService.showUnivShareLinkFiles = true;
                //localStorage.setItem('usID',suc.sessionId);
                self.universalService.headingTitle.set(suc["shareName"]);
                self.sessionStorageService.setUnivShareLinkSessionID(suc["ulinksToken"]);
                self.sessionStorageService.setUnivShareLinkShareKey(self.shareAccessService.univShareKey);
                self.sessionStorageService.setUnivShareLinkPswd(encryptedPswd);
                self.sessionStorageService.setShareLinkCreator(suc.shareCreatedBy);
                resolve(suc)
            },
            err=>{
              console.log("error in univ share link pswd info API is==>",err);
              if(err.error && err.error.code && err.error.code == "SSOM0123"){
                self.shareAccessService.wrongUlinkPwd = true;
              }
              reject(err)
            }
        )
    })
  }
  encryptPass(pswd) {
      return this.passwordEncryptorUtil.encryptShareLinkPassword(pswd);
  }

  
  public refreshShareSession(serviceUrl: string){ 
    var self = this;
    
    this.universalService.isRefreshShareEnabled=true;
  	UniversalService.refreshShareSession = setInterval(() =>{
			if(!document.hidden ){
        var param = {
          "shareKey" :  this.sessionStorageService.getUnivShareLinkShareKey(),
          "password" : this.sessionStorageService.getUnivShareLinkPswd()
        };
				this.http.post(serviceUrl,param).subscribe(
					(suc) => { 
            self.sessionStorageService.setUnivShareLinkSessionID(suc["ulinksToken"]);
         	},
					(error) => {
						//this.loggerService.log("ping fail")
					},
				);
			}
		}, this.shareSessionExpiry)

  }

  public refreshShareSessionImmediate(serviceUrl: string){ 
    var self = this;
    var param = {
      "shareKey" :  this.sessionStorageService.getUnivShareLinkShareKey(),
      "password" : this.sessionStorageService.getUnivShareLinkPswd()
    };
    this.http.post(serviceUrl,param).subscribe(
      (suc) => { 
        self.sessionStorageService.setUnivShareLinkSessionID(suc["ulinksToken"]);
      },
      (error) => {
        //this.loggerService.log("ping fail")
      },
    );
	}
  


}